export interface SocialsDto {
  instagram: string | null
  tiktok: string | null
  facebook: string | null
  twitter: string | null
}

export const equalSocials = (a: SocialsDto, b: SocialsDto): boolean => {
  return a.instagram === b.instagram &&
    a.tiktok === b.tiktok &&
    a.facebook === b.facebook &&
    a.twitter === b.twitter
}

export const emptySocials = (a: SocialsDto): boolean => {
  return !a.instagram &&
    !a.tiktok &&
    !a.facebook &&
    !a.twitter
}
